<template lang="pug">

.wrap
  .pb-6
    .weekday-name.pt-4
      span {{ currentDate.format('DD.MM.YYYY') }}
      span.ml-1 {{ weekDayName }}
      span.ml-1(v-if="isToday") (сегодня)

    v-card.mt-2
      .row-lessons.header
        .pair(v-if="!isTeachers") {{ isSchool ? 'Урок' : 'Пара' }}
        .time Время
        .others
          .subject Предмет
          .teacher(v-if="!isTeachers") {{ isSchool ? 'Учитель' : 'Преподаватель' }}
          .teacher(v-else) {{ isSchool ? 'Класс' : 'Группа' }}
          .cabinet {{ isSchool ? 'Кабинет' : 'Аудитория' }}

      .lessons-empty.pb-5(v-if="!times.length") Нет занятий

      row-lessons(
        v-for="row, i in times"
        :key="i"
        :row="row"
        :lessons="row.lessons"
        :is-teachers="isTeachers"
      )

</template>

<script>
import { mapGetters } from 'vuex'
import rowLessons from './rowLessons'

export default {
  name: 'cardLessonsColumn',

  components: {
    rowLessons
  },

  props: {
    weekday: {
      type: Number,
      required: true,
    },
    times: {
      type: Array,
      required: true,
    },
    isTeachers: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    }
  },

  computed: {
    ...mapGetters('navigations', ['date', 'startDate', 'endDate']),
    ...mapGetters('bootstrap', ['averageDuration', 'isSchool']),

    currentDate() {
      return moment(this.date).isoWeekday(this.weekday)
    },

    isToday() {
      return moment(this.date).isoWeekday(this.weekday).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY')
    },

    weekDayName() {
      const name = this.currentDate.format('dddd')

      return name[0].toUpperCase() + name.slice(1)
    },

    hasLessons() {
      return this.times.some((x) => x.lessons.length)
    },

    currentMinutes() {
      const mmt = moment()
      const mmtMidnight = mmt.clone().startOf('day')

      return mmt.diff(mmtMidnight, 'minutes')
    }
  },

  methods: {
    hasWindow(l1, l2) {
      return (l2.startTimeMin - l1.endTimeMin) > this.averageDuration
    },

    windowDuration(l1, l2) {
      const duration = l2.startTimeMin - l1.endTimeMin

      if (!duration) return ''

      const hours = Math.floor(duration / 60);
      const minutes = duration % 60
      let result = 'Окно: '

      if (hours) result += `${hours} ${this.$options.filters.plural(hours, 'час', 'часа', 'часов')} `
      if (minutes) result += `${minutes} мин.`

      return result.trim()
    },

    hasCurrentTime(row) {
      return this.isToday && row.startTimeMin < this.currentMinutes && this.currentMinutes < row.endTimeMin
    }
  }
}

</script>

<style lang="sass" scoped>
$borderColor: #d5d5d5
$pairWidth: 57px
$timeWidth: 100px

.row-lessons,
::v-deep .row-lessons
  display: flex
  width: 100%
  justify-content: stretch
  align-items: stretch
  font-size: 14px
  min-height: 40px
  border-bottom: 1px solid $borderColor
  border-radius: 0 !important

  &.header
    min-height: 25px
    font-size: 12px
    color: #717171
    border-top: 1px solid $borderColor

    .pair,
    .time,
    .teacher,
    .subject,
    .cabinet
      padding: 5px 12px
      font-size: 13px

  .others
    display: flex
    flex: 1 1 100%
    min-height: 100%

    .subject,
    .teacher
      flex: 1

    .cabinet
      flex: 1

  .pair,
  .time,
  .teacher,
  .subject,
  .cabinet
    display: flex
    align-items: center
    min-height: 100%
    font-size: 14px
    padding: 5px 12px
    word-break: break-word

    &:not(:last-child)
      border-right: 1px solid $borderColor

  .pair
    flex: 0 0 $pairWidth
    text-align: center

  .time
    flex: 0 0 $timeWidth


.weekday-name
  color: #0776cb

.lessons-empty
  width: 100%
  text-align: center
  margin-top: 20px
  font-size: 14px
  color: gray
</style>